"use client";
import { getDocument, isTextField } from "@ariakit/utils";
import * as Core from "@ariakit/components/composite/composite-store";
//#region src/composite/utils.ts
const flipItems = Core.flipItems;
const findFirstEnabledItem = Core.findFirstEnabledItem;
const groupItemsByRows = Core.groupItemsByRows;
/**
* Returns the store item with the given id (enabled or not), or `null`.
*/
function getEnabledItem(store, id) {
	if (!id) return null;
	return store.item(id) || null;
}
/**
* Selects text field contents even if it's a content editable element.
*/
function selectTextField(element, collapseToEnd = false) {
	if (isTextField(element)) element.setSelectionRange(collapseToEnd ? element.value.length : 0, element.value.length);
	else if (element.isContentEditable) {
		const selection = getDocument(element).getSelection();
		selection?.selectAllChildren(element);
		if (collapseToEnd) selection?.collapseToEnd();
	}
}
const FOCUS_SILENTLY = Symbol("FOCUS_SILENTLY");
/**
* Focus an element with a flag. The `silentlyFocused` function needs to be
* called later to check if the focus was silenced and to reset this state.
*/
function focusSilently(element) {
	element[FOCUS_SILENTLY] = true;
	element.focus({ preventScroll: true });
}
/**
* Checks whether the element has been focused with the `focusSilently` function
* and resets the state.
*/
function silentlyFocused(element) {
	const isSilentlyFocused = element[FOCUS_SILENTLY];
	delete element[FOCUS_SILENTLY];
	return isSilentlyFocused;
}
/**
* Determines whether the element is a composite item.
*/
function isItem(store, element, exclude) {
	if (!element) return false;
	if (element === exclude) return false;
	const item = store.item(element.id);
	if (!item) return false;
	if (exclude && item.element === exclude) return false;
	return true;
}
//#endregion
export { findFirstEnabledItem, flipItems, focusSilently, getEnabledItem, groupItemsByRows, isItem, selectTextField, silentlyFocused };

//# sourceMappingURL=utils.js.map